<script lang="ts" setup></script>
<template>
  <div
    id="search-results-listbox"
    role="listbox"
    class="search-dropdown top-100 start-0 end-0 position-absolute z-index-10"
  >
    <div class="search-dropdown-in bg-white p-4">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './SearchAutocompleteDropdown.scss';
</style>
